<template>
  <form novalidate @submit.prevent="submitQuote">
    <LsCheckboxes
      v-model="locations"
      :options="OrderServicesConstants.locations"
      label="Where on the property? (From the street)"
      track-id="cleanup_form-locations"
      name="locations"
      test-id="locations"
      :validation="{ required: true }"
    />
    <LsRadios
      v-model="desired_bed_cleanup"
      :validation="{ required: true }"
      label="Would you like your crew to also cleanup flower beds?"
      :options="QuoteCleanupOptions.desired_bed_cleanup"
      name="desired_bed_cleanup"
      track-id="cleanup_form-desired_bed_cleanup"
    />
    <LsCheckboxes
      v-model="debrisTypes"
      :validation="{ required: true }"
      label="What types of debris needs to be removed?"
      :options="QuoteCleanupOptions.debrisTypes"
      name="debrisTypes"
      track-id="cleanup_form-debrisTypes"
      @input="handleHasOther"
    />
    <LsInput
      v-if="showOtherDebris"
      v-model="other_debris"
      :validation="{ required: true }"
      track-id="cleanup_form-other_debris"
      test-id="other_debris"
      name="other_debris"
      type="textarea"
    />
    <LsRadios
      v-model="desired_haulaway"
      :validation="{ required: true }"
      label="Would you like your crew to get the debris hauled and disposed?"
      :options="QuoteCleanupOptions.desired_haulaway"
      name="desired_haulaway"
      track-id="cleanup_form-desired_haulaway"
    />
    <LsRadios
      v-model="last_service"
      :validation="{ required: true }"
      label="When was the last time you had cleanup done at your property?"
      :options="QuoteCleanupOptions.last_service"
      name="last_service"
      track-id="cleanup_form-last_service"
    />
    <LsInput
      v-model="details"
      track-id="cleanup_form-details"
      test-id="details"
      label="Any other details you would like your crew to know?"
      placeholder="Add as much detail as possible so that the provider can complete the job as per your expectations."
      name="details"
      type="textarea"
    />
    <LsInputMasked
      v-model="budget"
      track-id="cleanup_form-budget"
      test-id="budget"
      label="What is your budget for this work?"
      name="budget"
      mask="currency"
    />
    <LsUploadPhotos
      v-model="images"
      track-id="cleanup_form-images"
      test-id="images"
      label="Upload photos"
      name="images"
    />
    <LsButton
      text="get a price"
      track-id="cleanup_form-get_price"
      test-id="get_price"
      type="submit"
      :loading="orderServices.loadingStatus.isUpdating"
    />
  </form>
</template>

<script>
import _ from 'lodash';
import {
  LsButton,
  LsCheckboxes,
  LsInput,
  LsInputMasked,
  LsUploadPhotos,
  LsRadios,
} from '@/components/common';
import { QuoteCleanupOptions, OrderServicesConstants } from 'ls-constants';
import { mapActions, mapState } from 'vuex';
import { ORDER_SERVICES__SUBMIT_QUOTE } from '@/store/types';
import { lsRouterHelpers, lsValidationService } from 'ls-vue-common';
import { lsUploadPhotosHelper } from '@/helpers';

export default {
  name: 'CleanupForm',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsButton,
    LsInput,
    LsInputMasked,
    LsCheckboxes,
    LsUploadPhotos,
    LsRadios,
  },
  data() {
    return {
      property_id: lsRouterHelpers.getParam(this.$route, 'property_id'),
      service_id: lsRouterHelpers.getParam(this.$route, 'service_id'),

      // form
      locations: [],
      desired_bed_cleanup: null,
      debrisTypes: [],
      other_debris: '',
      desired_haulaway: true,
      last_service: null,
      details: '',
      budget: '',
      images: [],

      // visual
      showOtherDebris: false,
    };
  },
  computed: {
    ...mapState(['orderServices']),
    OrderServicesConstants() {
      return _.cloneDeep(OrderServicesConstants);
    },
    QuoteCleanupOptions() {
      return _.cloneDeep(QuoteCleanupOptions);
    },
  },
  methods: {
    ...mapActions([ORDER_SERVICES__SUBMIT_QUOTE]),
    async submitQuote() {
      const isFormValid = await this.$validator.validateAll();
      const isUploadValid = lsUploadPhotosHelper.isValidUpload(this.images);

      if (!isFormValid || !isUploadValid) {
        return lsValidationService.scrollToInvalid();
      }

      const additional = {
        desired_bed_cleanup: this.desired_bed_cleanup,
        other_debris: this.other_debris ? this.other_debris : null,
        desired_haulaway: this.desired_haulaway,
        last_service: this.last_service,
        details: this.details ? this.details : null,
      };

      _.forEach(this.debrisTypes, (type) => {
        additional[type] = true;
      });

      this[ORDER_SERVICES__SUBMIT_QUOTE]({
        property_id: this.property_id,
        service_id: this.service_id,
        formData: {
          additional,
          budget: this.budget,
          images: this.images,
          locations: this.locations,
        },
      });
    },
    handleHasOther(evt) {
      const hasOtherIsSelected = _.includes(evt, 'has_other');
      this.showOtherDebris = hasOtherIsSelected;
      if (!hasOtherIsSelected) {
        this.other_debris = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
form > :not(:last-child) {
  margin-bottom: 40px !important;
}
</style>
